module.exports = __webpack_public_path__ + "static/media/child.900662ba.png";